module.exports = __webpack_public_path__ + "img/banner.f3998273.png";